import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg, fmtDate } from "@/lib/api";
import { PageHead } from "./Layout";

export default function Billing() {
  const [q, setQ] = useSearchParams();
  const [b, setB] = useState<any>(null);
  const [busy, setBusy] = useState(false);
  const [checking, setChecking] = useState(false);
  useEffect(() => {
    const sid = q.get("session_id");
    if (!sid) { api.get("/billing").then((r) => setB(r.data)); return; }
    setChecking(true);
    let tries = 0;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/billing/checkout-status/${sid}`);
        setB(data);
        if (data.entitlement?.active || tries >= 8) { setChecking(false); setQ({}, { replace: true }); return; }
      } catch { setChecking(false); return; }
      setTimeout(poll, 2000);
    };
    poll();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const go = async (path: string, key: string) => {
    setBusy(true);
    try { const { data } = await api.post(path, { origin_url: window.location.origin }); window.location.href = data[key]; }
    catch (e) { toast.error(errMsg(e)); setBusy(false); }
  };
  if (!b) return <p className="text-muted-foreground">{checking ? "Confirming your payment with Stripe…" : "Loading…"}</p>;
  const active = b.entitlement?.active;
  return (
    <div className="fade-up max-w-2xl">
      <PageHead title="Billing" sub="Your Instant Quote Wizard subscription. Homeowner payments are not processed here." />
      {b.mode === "test" && <p className="text-xs bg-amber-50 border border-amber-200 text-amber-900 rounded-lg p-3 mb-4" data-testid="stripe-test-mode-banner">Stripe test mode — use card 4242 4242 4242 4242, any future date, any CVC. No real charges.</p>}
      {q.get("checkout") === "cancel" && <p className="text-sm text-muted-foreground mb-4">Checkout was cancelled.</p>}
      <div className="bg-card border rounded-xl p-6">
        <p className="text-xs uppercase tracking-wider text-muted-foreground">Plan</p>
        <p className="font-heading text-2xl font-bold mt-1">{b.plan}</p>
        <div className="mt-4 text-sm space-y-1">
          <p>Status: <b data-testid="billing-status">{b.status}</b> {checking && "(confirming…)"}</p>
          <p>Widget access: <b className={active ? "text-primary" : "text-destructive"} data-testid="billing-entitlement">{active ? `Active (${b.entitlement.reason})` : "Inactive"}</b></p>
          {b.current_period_end && <p data-testid="billing-period">{b.cancel_at_period_end ? "Cancels on" : "Renews"}: {fmtDate(b.current_period_end)}</p>}
          <p className="text-xs text-muted-foreground">Applicable sales tax may be added at checkout based on your billing address.</p>
        </div>
        <div className="mt-6 flex flex-wrap gap-3">
          {b.status !== "active" && b.status !== "trialing" && <Button onClick={() => go("/billing/checkout", "checkout_url")} disabled={busy} className="h-11" data-testid="subscribe-button">Subscribe — $99/month</Button>}
          {b.has_customer && <Button variant="outline" onClick={() => go("/billing/portal", "portal_url")} disabled={busy} className="h-11" data-testid="manage-billing-button">Manage billing</Button>}
        </div>
      </div>
    </div>
  );
}
